export const environment = {
  production: true,
  firebaseConfig : {
    apiKey: "AIzaSyAUed8Qoqrp-_HKkoy7WsGpDydPNOiqWDI",
    authDomain: "hurghada-radio.firebaseapp.com",
    databaseURL: "https://hurghada-radio-default-rtdb.firebaseio.com",
    projectId: "hurghada-radio",
    storageBucket: "hurghada-radio.appspot.com",
    messagingSenderId: "396612690152",
    appId: "1:396612690152:web:355f9a1cd7da0c669be95d",
    measurementId: "G-44Q7STHRR7"
  },
  // TODO: replace this with your real public VAPID key from Firebase Console → Cloud Messaging
  vapidKey: 'BMZbAx-aumTHoaIrVlvNpI8L-j6AawBjaEgu-VLbeikw4lxw0rJp4Ctydj3Ka-cHk850pUmrfN4bZyJRUbly40c'
};
